import PropTypes from 'prop-types';

import NotFoundSvg from '../../assets/svg/not-found.svg';
import { Container, Image, Text } from './styles';

const propTypes = {
  text: PropTypes.string.isRequired,
};

const NoProjectsFound = ({ text }) => (
  <Container>
    <Text>{text}</Text>
    <Image src={NotFoundSvg} alt="Não encontrado" />
  </Container>
);

NoProjectsFound.propTypes = propTypes;

export default NoProjectsFound;
